import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    template: `
        <div mat-dialog-title>{{title}}</div>
        <div mat-dialog-content>
            <div fxLayout="column" style="width: 500px;">
                <h5 *ngFor="let instruction of instructions" style="margin: 4px 0px;">{{instruction}}</h5>
                <mat-form-field>
                    <input matInput [formControl]="emailAddress" placeholder="Email Address">
                    <mat-error *ngIf="emailAddress.errors?.required">Email Address is required.</mat-error>
                    <mat-error *ngIf="emailAddress.errors?.pattern">Email address must be valid.</mat-error>
                </mat-form-field>
            </div>
        </div>
        <div mat-dialog-actions>
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-raised-button 
                    color="primary" 
                    [disabled]="emailAddress.disabled" 
                    [mat-dialog-close]="emailAddress.value">{{actionLabel}}</button>
        </div>
    `
})
export class EmailAddressDialogComponent {
    title: string;
    instructions: string[];
    actionLabel: string;
    emailAddress: FormControl;
    
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.title = data.title || 'Email Address';
        this.actionLabel = data.actionLabel || 'Save';
        this.instructions = data.instructions;
        this.emailAddress = new FormControl('', {
            validators: [
                Validators.required, 
                Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,63}$')
            ]
        });
    }
}